import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Slide,
  Typography,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { forwardRef, useContext, useEffect, useState } from "react";
import {
  verifyDataLocalStorage,
  verifyIncludesPropertiesCerKeyList,
} from "utils/_verifyDataLocalStorage";
import { FirmaElectronicaContext } from "../context/firmaElectronicaContext";
import { CertificadoInterface } from "../interfaces/firmaInterfaces";
import { Certificado } from "./certificado";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const ModalCertificadosGuardados = () => {
  const { showCertificadosGuardados, handleClickShowCerKeySave } = useContext(
    FirmaElectronicaContext
  );
  const [certificados, setCertificados] = useState<CertificadoInterface[]>([]);

  useEffect(() => {
    if (localStorage.getItem("certKeyList")) {
      const result = verifyDataLocalStorage(
        localStorage.getItem("certKeyList")!,
        verifyIncludesPropertiesCerKeyList
      );

      if (typeof result === "string") {
        localStorage.removeItem("certKeyList");
        setCertificados([]);
      } else {
        setCertificados(JSON.parse(localStorage.getItem("certKeyList")!));
      }
    }
    // eslint-disable-next-line
  }, [localStorage.getItem("certKeyList")]);

  const handleDeleteCertificado = (certificado: CertificadoInterface) => {
    const newCerKeyList = certificados.filter(
      (args: CertificadoInterface) => args.cert.name !== certificado.cert.name
    );
    localStorage.setItem("certKeyList", JSON.stringify(newCerKeyList));
    setCertificados(newCerKeyList);
  };

  return (
    <Dialog
      open={Boolean(showCertificadosGuardados)}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClickShowCerKeySave}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>Certificados Guardados</DialogTitle>
      <Divider />
      <DialogContent>
        {!certificados.length ? (
          <Typography>No se encuentran certificados guardados</Typography>
        ) : (
          certificados.map((certificado: any) => (
            <Certificado
              certificado={certificado}
              key={certificado.cert?.name}
              handleDeleteCertificado={handleDeleteCertificado}
            />
          ))
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClickShowCerKeySave(false)}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};
